<template>
  <form ref="formRef" novalidate @submit.prevent="saveOrigen" class="d-flex align-items-center gap-4 fondo-terciario rounded-4 p-3 px-4 sombra-sm mb-4">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-3 w-100">
        <h2 class="fw-bold fs-5 m-0 mt-1">{{ $t('origenYNacionalidad') }}</h2>
        <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
          <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
        </div>
        <button @click="isEditingOrigen = true" v-if="(hasEditarPersonaPermission && !isEditingOrigen) || isEditingPerfil" type="button" class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0">
          <svg width="20" height="20" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('editar') }}</span>
        </button>
      </div>
      <!-- Pais de Nacimiento -->
      <div class="mb-3 d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('paisDeNacimiento') }}{{ isEditingOrigen && isEditingPerfil ? '*' : '' }}:</label>
        <p v-if="!isEditingOrigen" class="m-0">{{ localPersona.PaisNacimiento?.NombrePais || 'N/A' }}</p>
        <div v-if="isEditingOrigen" class="select-wrapper w-100 position-relative">
          <select id="paisNacimiento" v-model="localPersona.IdPaisNacimiento" class="form-select fondo-principal sombra-sm" @change="vaciarProvinciaNacimiento()" :disabled="!isEditingOrigen" required>
            <option v-for="pais in paises" :key="pais.IdPais" :value="pais.IdPais">{{ pais.NombrePais }}</option>
          </select>
          <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
          </svg>
          <div class="invalid-feedback position-absolute" style="position: absolute !important;">{{ $t('paisRequerido') }}</div>
        </div>
      </div>
      <!-- Provincia de Nacimiento -->
      <div class="mb-3 d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('provinciaDeNacimiento') }}{{ isEditingOrigen && isEditingPerfil ? '*' : '' }}:</label>
        <p v-if="!isEditingOrigen" class="m-0">{{ localPersona?.ProvinciaNacimiento?.NombreProvincia || 'N/A' }}</p>
        <div v-if="isEditingOrigen" class="select-wrapper w-100 position-relative">
          <select id="provinciaNacimiento" v-model="localPersona.IdProvinciaNacimiento" class="form-select fondo-principal sombra-sm" @change="vaciarLocalidadNacimiento()" :disabled="!isEditingOrigen" required>
            <option v-for="provincia in provinciasNacimiento" :key="provincia.IdProvincia" :value="provincia.IdProvincia">{{ provincia?.NombreProvincia }}</option>
          </select>
          <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
          </svg>
          <div class="invalid-feedback position-absolute" style="position: absolute !important;">{{ $t('provinciaRequerida') }}</div>
        </div>
      </div>
      <!-- Localidad de Nacimiento -->
      <div class="mb-3 w-100" v-if="(localPersona.IdPaisNacimiento == '1f3517df-5c00-471b-8883-91d73a902eb4' && isEditingOrigen) || localPersona?.LocalidadNacimiento?.NombreLocalidad">
        <div class="d-flex flex-column w-100">
          <label for="localidad" class="m-0 texto-secundario fs-7">{{ $t('localidadDeNacimiento') }}:</label>
          <p v-if="!isEditingOrigen" class="m-0 w-100">{{ localPersona.LocalidadNacimiento.NombreLocalidad || 'N/A' }}</p>
          <div v-if="isEditingOrigen" class="d-flex gap-2 w-100 position-relative">
            <div class="d-flex flex-row align-items-center gap-2 w-100">
              <div class="position-relative w-100 d-flex flex-row">
                <input type="text" v-model="searchQueryLocalidadNacimiento" class="form-control fondo-principal w-100 sombra-sm" @input="filterLocalidadNacimiento()" :disabled="!isEditingOrigen"/>
                <ul v-if="filteredLocalidadNacimiento.length > 0"
                  class="list-group position-absolute sombra-sm"
                  style="z-index: 1000; width: 100%; top: 100%; max-height: 200px; overflow-y: auto;">
                  <li v-for="Localidad in filteredLocalidadNacimiento"
                    :key="Localidad.IdLocalidad"
                    class="list-group-item list-group-item-action d-flex flex-column"
                    @click="selectLocalidadNacimiento(Localidad)"
                    style="cursor: pointer;">
                    <span class="fs-7">{{ Localidad.NombreLocalidad }}</span>
                  </li>
                </ul>
                <div v-if="loadingLocalidades" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                  <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
                </div>
                <div class="invalid-feedback">{{ $t('localidadRequerida') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Nacionalidad -->
      <div class="d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('nacionalidades') }}{{ isEditingOrigen && isEditingPerfil ? '*' : '' }}:</label>
        <p v-if="!isEditingOrigen" class="m-0">{{ listaNacionalidadesTexto }}</p>
        <div v-if="isEditingOrigen">
          <div v-for="(nacionalidad, index) in localPersona.PersonasNacionalidads" :key="'nacionalidad' + index"  class="d-flex flex-row gap-2 mb-2">
            <div class="select-wrapper w-100 position-relative">
              <select v-model="nacionalidad.IdNacionalidad" class="form-select fondo-principal sombra-sm" :disabled="!isEditingOrigen" required>
                <option v-for="n in nacionalidades" :key="n.IdNacionalidad" :value="n.IdNacionalidad">{{ n.nacionalidad }}</option>
              </select>
              <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
              </svg>
              <div class="invalid-feedback position-absolute" style="position: absolute !important;">{{ $t('nacionalidadRequerida') }}</div>
            </div>
            <button v-if="index > 0" type="button" class="btn danger-btn p-2 d-flex flex-row align-items-center justify-content-center" @click="removeNacionalidad(index)">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 5C9 3.89543 9 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <button type="button" class="btn btn-primary mt-2" @click="addNacionalidad">
            {{ $t('agregarNacionalidad') }}
          </button>
        </div>
      </div>
      <div v-if="isEditingOrigen" class="d-flex justify-content-end gap-2 mt-3">
        <button class="btn success-btn sombra-sm d-flex align-items-center gap-2" type="submit" :disabled="loadingOrigen">
          {{ $t('guardarCambios') }}
          <img v-if="loadingOrigen" src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
        </button>
        <button class="btn secondary-btn sombra-sm" type="button" @click="isEditingOrigen = false">{{ $t('cancelar') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'OrigenYNacionalidadSection',
  props: {
    persona: {
      type: Object,
      default: () => ({})
    },
    hasEditarPersonaPermission: {
      type: Boolean,
      default: false
    },
    isEditingPerfil: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const isEditingOrigen = ref(false);
    const loadingOrigen = ref(false);
    const loading = ref(false);
    const localPersona = ref({ ...props.persona });
    const searchQueryLocalidadNacimiento = ref('');
    const filteredLocalidadNacimiento = ref([]);
    const loadingLocalidades = ref(false);

    // Data refs
    const paises = ref([]);
    const provinciasNacimiento = ref([]);
    const localidadesNacimiento = ref([]);
    const nacionalidades = ref([]);
    const errors = ref({});
    const formRef = ref(null);


    const fetchProvinciasNacimiento = async (idPais) => {
      try {
        const response = await api.get(`api/ExtrasPersonas/Provincias/ByPais/${idPais}`);
        provinciasNacimiento.value = response.data;
      } catch (error) {
        console.error('Error al obtener provincias de nacimiento:', error);
      }
    };

    const fetchOrigenYNacionalidad = async (personaId) => {
      try {
        loading.value = true;
        const response = await api.get(`api/Persona/${personaId}/origen-nacionalidad`);

        localPersona.value.PersonasNacionalidads = response.data.PersonasNacionalidads
        localPersona.value.LocalidadNacimiento = response.data.LocalidadNacimiento
        localPersona.value.ProvinciaNacimiento = response.data.ProvinciaNacimiento
        localPersona.value.PaisNacimiento = response.data.PaisNacimiento
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.error('Error al obtener direcciones:', error);
      }
    };


    const fetchLocalidadesNacimiento = async (idProvincia) => {
      try {
        loadingLocalidades.value = true;
        const response = await api.get(`api/ExtrasPersonas/Localidades/ByProvincia/${idProvincia}`);
        localidadesNacimiento.value = response.data;
        loadingLocalidades.value = false;
      } catch (error) {
        loadingLocalidades.value = false;
        console.error('Error al obtener localidades de nacimiento:', error);
      }
    };

    const listaNacionalidadesTexto = computed(() => {
      if (!localPersona.value.PersonasNacionalidads || localPersona.value.PersonasNacionalidads.length === 0) {
        return 'N/A';
      }
      if (!nacionalidades.value || nacionalidades.value.length === 0) {
        return 'N/A';
      }
      const nombresNacionalidades = localPersona.value.PersonasNacionalidads
        .map(pN => {
          const nacion = nacionalidades.value.find(n => n.IdNacionalidad === pN.IdNacionalidad);
          return nacion ? nacion.nacionalidad : '';
        })
        .filter(name => name);
      return nombresNacionalidades.join(', ');
    });

    const fetchPaises = async () => {
      try {
        const response = await api.get(`api/ExtrasPersonas/Paises`);
        paises.value = response.data;
      } catch (error) {
        console.error('Error al obtener paises:', error);
      }
    };

    const fetchNacionalidades = async () => {
      try {
        const response = await api.get(`api/ExtrasPersonas/Nacionalidades`);
        nacionalidades.value = response.data;
      } catch (error) {
        console.error('Error al obtener nacionalidades:', error);
      }
    };
    const vaciarProvinciaNacimiento = () => {
      localPersona.value.IdProvinciaNacimiento = null
      localPersona.value.ProvinciaNacimiento = null
      fetchProvinciasNacimiento(localPersona.value.IdPaisNacimiento); 
      vaciarLocalidadNacimiento()
    }

    const vaciarLocalidadNacimiento = () => {
      localPersona.value.IdLocalidadNacimiento = null
      localPersona.value.LocalidadNacimiento = null
      searchQueryLocalidadNacimiento.value = null
      filteredLocalidadNacimiento.value = [];
      fetchLocalidadesNacimiento(localPersona.value.IdProvinciaNacimiento); 
    }

    const filterLocalidadNacimiento = () => {
      if (searchQueryLocalidadNacimiento.value === '') {
        filteredLocalidadNacimiento.value = [];
        return;
      }
      const query = searchQueryLocalidadNacimiento.value.toLowerCase();
      filteredLocalidadNacimiento.value = localidadesNacimiento.value.filter(localidad =>
        localidad.NombreLocalidad.toLowerCase().includes(query)
      );
    };

    const selectLocalidadNacimiento = (localidad) => {
      searchQueryLocalidadNacimiento.value = localidad.NombreLocalidad;
      filteredLocalidadNacimiento.value = [];
      localPersona.value.IdLocalidadNacimiento = localidad.IdLocalidad;
    };

    const addNacionalidad = () => {
      if (!localPersona.value.PersonasNacionalidads) {
        localPersona.value.PersonasNacionalidads = [];
      }
      localPersona.value.PersonasNacionalidads.push({ IdNacionalidad: null });
    };

    const removeNacionalidad = (index) => {
      localPersona.value.PersonasNacionalidads.splice(index, 1);
    };

    const validateOrigen = async () => {
      errors.value = {};
      let isValid = true;
      if (props.isEditingPerfil) {
        if (!localPersona.value.IdPaisNacimiento) {
          errors.value.IdPaisNacimiento = t('paisRequerido');
          isValid = false;
        }
        if (!localPersona.value.IdProvinciaNacimiento) {
          errors.value.IdProvinciaNacimiento = t('provinciaRequerida');
          isValid = false;
        }
        if (!localPersona.value.PersonasNacionalidads || localPersona.value.PersonasNacionalidads.length === 0 || localPersona.value.PersonasNacionalidads.some(pn => !pn.IdNacionalidad)) {
          errors.value.PersonasNacionalidads = t('nacionalidadRequerida');
          isValid = false;
        }
      }else{
        if (!localPersona.value.IdProvinciaNacimiento && localPersona.value.IdPaisNacimiento) {
          errors.value.IdProvinciaNacimiento = t('provinciaRequerida');
          isValid = false;
        }
      }
      await nextTick();
      if (!isValid) {
        formRef.value?.classList.add('was-validated');
      } else {
        formRef.value?.classList.remove('was-validated');
      }
      return isValid;
    };

    const saveOrigen = async () => {
      if (!await validateOrigen()) {
        return;
      }
      loadingOrigen.value = true;
      try {
        const data = {
          idLocalidadNacimiento: localPersona.value.IdLocalidadNacimiento,
          idProvinciaNacimiento: localPersona.value.IdProvinciaNacimiento,
          personasNacionalidads: localPersona.value.PersonasNacionalidads.map(pn => ({ idNacionalidad: pn.IdNacionalidad }))
        };
        await api.put(`api/Persona/${props.persona.IdPersona}/origen-nacionalidad`, data);
        isEditingOrigen.value = false;
        emit('updated');
      } catch (error) {
        console.error('Error al guardar origen y nacionalidad:', error);
        alert('Hubo un problema al guardar el origen y nacionalidad.');
      } finally {
        loadingOrigen.value = false;
      }
    };

    watch(() => props.persona, (newPersona) => {
      const handleUpdate = async () => {
        localPersona.value = { ...newPersona };

        // Call fetches based on new persona
        if(localPersona.value.IdPersona){
          await fetchOrigenYNacionalidad(localPersona.value.IdPersona);
        }

        if (localPersona.value.ProvinciaNacimiento != null) {
          localPersona.value.IdPaisNacimiento = localPersona.value.ProvinciaNacimiento?.IdPais
          // Si fetchProvinciasNacimiento es async, también necesita await
          await fetchProvinciasNacimiento(localPersona.value.ProvinciaNacimiento.IdPais);
        }

        if (localPersona.value.IdPaisNacimiento == '1f3517df-5c00-471b-8883-91d73a902eb4') {
          // Si fetchLocalidadesNacimiento es async, también necesita await
          await fetchLocalidadesNacimiento(localPersona.value.IdProvinciaNacimiento);
        }
        if (localPersona.value.LocalidadNacimiento != null) {
          searchQueryLocalidadNacimiento.value = localPersona.value.LocalidadNacimiento?.NombreLocalidad;
        }

        // If in editing profile mode and no nationalities, add an empty one
        if (props.isEditingPerfil && (!localPersona.value.PersonasNacionalidads || localPersona.value.PersonasNacionalidads.length === 0)) {
          localPersona.value.PersonasNacionalidads = [{ IdNacionalidad: null }];
        }
      };

      handleUpdate();
    }, { immediate: true });

    onMounted(async () => {
      await fetchPaises();
      await fetchNacionalidades();
    });

    return {
      t,
      isEditingOrigen,
      loadingOrigen,
      localPersona,
      searchQueryLocalidadNacimiento,
      filteredLocalidadNacimiento,
      loadingLocalidades,
      paises,
      provinciasNacimiento,
      localidadesNacimiento,
      nacionalidades,
      listaNacionalidadesTexto,
      filterLocalidadNacimiento,
      selectLocalidadNacimiento,
      addNacionalidad,
      removeNacionalidad,
      saveOrigen,
      fetchProvinciasNacimiento,
      fetchLocalidadesNacimiento,
      vaciarProvinciaNacimiento,
      vaciarLocalidadNacimiento,
      validateOrigen,
      errors,
      formRef,
      loading
    };
  },
};
</script>

<style>
</style>